import { gql } from '@apollo/client';
import { PROGRAMME } from '../fragments';

export const FILTERED_PROGRAMMES = gql`
  query FilteredProgrammes($input: FilterProgrammes!) {
    programmes: filteredProgrammes(input: $input) {
      ...programme
      serviceProviders {
        id
      }
      interventions {
        id
      }
    }
  }
  ${PROGRAMME}
`;
